<template>
    <div class="modal-card" style="width:360px">
        <header class="modal-card-head">
            <p class="modal-card-title">Firmadetaljer</p>
        </header>
        
        <section class="modal-card-body">
            <b-field label="BransjeId">
                <b-input v-model="branch.id" required></b-input>
            </b-field>

            <b-field label="Tittel">
                <b-input v-model="branch.name" required></b-input>
            </b-field>

            <div class="field" v-if="errorMsg">
                <span class="is-danger">{{ errorMsg }}</span>
            </div>

        </section>

        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">Avbryt</button>
            <button class="button is-primary" @click="commitChanges()">Ok</button>
        </footer>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: ['branch'],
    data () {
        return {
            errorMsg: undefined
        }
    },
    methods: {
        ...mapActions('products', ['saveBranch']),
        async commitChanges () {
            try {
                await this.saveBranch(this.branch)
                this.$parent.close()
            } catch (error) {
                this.errorMsg = error.message
            }
        }
    }
}
</script>
